import { NgModule, ApplicationRef } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HomeComponent, HomeModule } from './home';

@NgModule({
  imports: [
    AppRoutingModule,
    CoreModule.forRoot(),
    HomeModule

  ],
  declarations: [
    AppComponent
  ],
  providers: [{
    provide: 'externalUrlRedirectResolver',
    useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    {
        window.location.href = (route.data as any).externalUrl;
    }
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/fabiano/git/assinador-showcase/frontend/src/app/app.module.ts